import React, { useEffect, useRef, useState } from 'react';
import Styles from './ButtonStyles.module.scss';
import {
  getFormattedUsername,
  loginCalls,
  MyPolicyCallByAction,
  removeSpaces
} from '../../../services/LoginServiceV2';
import { API_BASE_BASEPOINT } from '../../../services/api-constants';
import RichText from '../../richtext';
import { OTP_NR_NEW, LOGIN_OTP, PW_FORGOT } from '../../../utils/constants';
import { Spinner } from 'react-bootstrap';
import { NewNumberSchema } from '../Login.types';
import mainStyles from '../ReusableLogin.module.scss';

const NewNumber: React.FC<NewNumberSchema> = ({
  useCase,
  content,
  changeCurrentView,
  metadata,
  userID,
  loginIcons,
  response,
  errorContent
}: any) => {
  const numberRegex: any = /^[0-9]+$/;
  const [error, setError] = useState(true);
  const [inputValue, setInputValue] = useState(userID ?? '');
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [wrongMsisdn, setWrongMsisdn] = useState(false);
  const [techError, setTechError] = useState(false);
  const controllerRef = useRef<AbortController | null>(null);;

  const handleChange = (value: string) => {
    setInputValue(value);
    setWrongMsisdn(false);
    if (numberRegex.test(value) && value?.length >= 10) {
      setError(false);
    } else {
      setError(true);
    }
  };

  const handleClick = () => {
    if (showLoader) {
      controllerRef?.current?.abort();
    }
    setShowLoader(true);
    setTechError(false);
    setWrongMsisdn(false);
    if (useCase === OTP_NR_NEW) {
      MyPolicyCallByAction(useCase, inputValue, controllerRef)
        .then((res: any) => {
          setShowLoader(false);
          if (res?.status) {
            if (res?.error === 'MSISDN_INVALID' || res?.status === 'NOK') {
              setWrongMsisdn(true);
            } else if (res?.status !== 'ERROR') {
              changeCurrentView('', res);
            } else {
              setTechError(true);
            }
          } else {
            setTechError(true);
          }
        })
        .catch((err) => {
          setShowLoader(false);
          setTechError(true);
          console.log(err);
        });
    }
    if (useCase === LOGIN_OTP || useCase === PW_FORGOT) {
      const formatedUserName = getFormattedUsername(removeSpaces(inputValue));
      loginCalls(
        useCase,
        API_BASE_BASEPOINT?.LOGIN_OTP,
        formatedUserName,
        '',
        controllerRef,
        metadata?.lang
      )
        .then((res: any) => {
          setShowLoader(false);
          if (res?.status && res?.status !== 'NOK' && res?.status !== 'ERROR') {
            changeCurrentView('', res);
          } else {
            setTechError(true);
          }
        })
        .catch((err) => {
          setShowLoader(false);
          setTechError(true);
          console.log(err);
        });
    }
  };

  const onKeyDown = (e: any) => {
    if (e?.key === 'Enter' && !(error || showLoader)) {
      handleClick();
    }
  };

  //To prefill the number from previous screen in case of temp code and forgot pswd 
  useEffect(() => {
    if (userID) {
      handleChange(userID);
    }
  }, [userID]);

  useEffect(() => {
    if (useCase === OTP_NR_NEW && response?.msisdn && !isNaN(Number(response?.msisdn))) {
      handleChange(response?.msisdn);
    }
  }, [response, useCase]);

  return (
    <div className={Styles.Container}>
      {content?.title && <h2 className='text-center mb-4 mt-4'>{content?.title}</h2>}
      {content?.descriptionV2 && <RichText content={content?.descriptionV2} />}
      <div className={`form-floating  w-100 ${Styles.inputField}`}>
        <input
          type='number'
          id={useCase}
          placeholder={content?.userNameLabel ?? ''}
          value={inputValue}
          className={`form-control ${(techError || wrongMsisdn) && 'error-border mb-4'}`}
          onChange={(e) => handleChange(e?.target?.value)}
          onKeyDown={onKeyDown}
          // disabled={error}
        />
        {content?.userNameLabel && (
          <label className={`text-truncate w-100 ${mainStyles.loginmodalLabel}`}>{content?.userNameLabel}</label>
        )}
        {wrongMsisdn && errorContent?.invalidNumberMessage && (
          <p className={mainStyles.credentialerror}>
            <img src={loginIcons?.alertTriangle?.filename} alt='alert' className={mainStyles.warningicon} />
            {errorContent?.invalidNumberMessage}
          </p>
        )}
        {techError && errorContent?.technicalError && (
          <p className={mainStyles.credentialerror}>
            <img src={loginIcons?.alertTriangle?.filename} alt='alert' className={mainStyles.warningicon} />
            {errorContent?.technicalError}
          </p>
        )}
        {content?.infoText && <span>{content?.infoText}</span>}
      </div>
      {content?.buttonLabel && (
        <div className='text-center mt-4'>
          {showLoader && (
            <Spinner
              as='span'
              animation='border'
              size='sm'
              role='status'
              aria-hidden='true'
              className='d-block mx-auto mb-3'
            />
          )}
          <button
            className={Styles.continueButton}
            disabled={error || showLoader}
            onClick={handleClick}
          >
            {content?.buttonLabel}
          </button>
        </div>
      )}
    </div>
  );
};

export default NewNumber;
